<template>
  <v-app id="payment">
    <v-content class="good-gray">
      <div id="payment-container" style="margin-bottom: 50px;">
        <v-alert text :color="v_alert.color" border="left" :type="v_alert.type"
                 class="pa-6 mx-5 w-100" v-if="v_alert.displayed">{{v_alert.text}}
        </v-alert>
        <p>Steppi</p>
        <h2>Steppi B.V.</h2>
        <h2>iDEAL</h2>
        <h2>€ {{amount}}</h2>
        <div class="paymentmethods-container" style="padding-bottom: 30px;">
          <template v-for="(value, name) in banks">
            <div class="payment-line" @click="pay(name)" :key="value">
              <label>{{value}}</label>
              <span>></span>
            </div>
          </template>
          <v-btn text @click="back()" style="margin-top:20px; float:left;">Terug</v-btn>
        </div>
      </div>
    </v-content>
  </v-app>
</template>
<script>
import {mapActions, mapState} from "vuex";

export default {
  data: () => ({
    banks: {
      "abn_amro": "ABN Amro",
      "asn_bank": "ASN Bank",
      "bunq": "Bunq",
      "ing": "ING",
      "knab": "Knab",
      "moneyou": "Moneyou",
      "rabobank": "Rabobank",
      "regiobank": "Regiobank",
      "sns_bank": "SNS Bank",
    },
    paymentId: "",
    payment: {},
    amount: "",
    v_alert: {
      color: "",
      type: "",
      text: "",
      displayed: false,
    },
    url: null,
  }),
  mounted() {
    this.paymentId = this.$route.params.id;
    this.url = this.$route.params.secret;

    if(this.paymentId===undefined){
      this.redirectCountry();
    }else{
      this._getPaymentById(this.paymentId)
          .then((data) => {
            if(!data){
              this.redirectCountry();
            }else{
              this.payment = data;
              this.amount = this.payment.total.toString();
              if(this.amount.includes('.')){
                this.amount = this.amount.replace('.', ',');
              }else{
                this.amount = this.payment.total + ',00';
              }
            }
          });
    }
  },
  methods: {
    ...mapActions('payment', [
      '_idealPayment',
      '_getPaymentById'
    ]),
    pay(bank){
      this.loading();
      this._idealPayment([bank, this.payment])
          .then((data) => {
              if(data!==undefined || data){
                this.perfect();
                window.location.href = data;
              }else{
                this.wrong();
              }
           })
          .catch(() => {
            this.wrong();
          });
    },
    back(){
      if(this.url === null || this.url === undefined){
        this.$router.push({ name: 'payment', params: { payment: this.payment.id }})
      }else{
        this.$router.push({ name: 'payment-link', params: { id: this.payment.id, secret: this.url }});

      }
    },
    wrong(){
      this.v_alert.color = "red";
      this.v_alert.type = "error";
      this.v_alert.text = "Er is iets mis gegaan, probeer het opnieuw";
      this.v_alert.displayed = true;
    },
    loading(){
      this.v_alert.color = "blue";
      this.v_alert.type = "info";
      this.v_alert.text = "Een betaling wordt gemaakt";
      this.v_alert.displayed = true;
    },
    perfect(){
      this.v_alert.color = "green";
      this.v_alert.type = "success";
      this.v_alert.text = "U wordt door gestuurd";
      this.v_alert.displayed = true;
    },
  }
};
</script>
<style src="../Payment/Payment.scss" scoped lang="scss"></style>

